export default "__VITE_ASSET__pc6i00X9__"